import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { store } from "../redux/store";
import { useCallback, useEffect, useState } from "react";
import { useApi } from "../hooks/useApi";
import { useRedux } from "../hooks/useRedux";

import AuthenticationService from "../services/Authentication.service";

import { onClientReducer } from "../redux/slices/userReducer";
import { addAuthToken } from "../redux/slices/authTokenReducer";
import { IAccount } from "../interfaces/api/IAccount.inteface";

import InformationRequeriments from "../pages/information-requirements";
import AccountOpening from "../pages/account-opening";
import ValidateCode from "../pages/validate-code";
import IneConsent from "../pages/ine-consent";
import TermsCondition from "../pages/terms-conditions";
import CaptureINE from "../pages/capture-ine";
import DataConfirmation from "../pages/data-confirmation";
import AddressCondition from "../pages/address-condition";
import ProofAddressCondition from "../pages/proof-address-condition";
import SuggestionCaptureReceipt from "../pages/suggestion-capture-receipt";
import BlackLists from "../pages/black-lists";
import FiscalInformationClient from "../pages/fiscal-formation";
import LaborInformation from "../pages/labor-information";
import UseAccountManagement from "../pages/use-account-management";
import BeneficiariesClient from "../pages/beneficiaries";
import BeneficiariesCheckClient from "../pages/beneficiaries-check";
import IdentificationQuestionnaire from "../pages/identification-questionnaire";
import LivenessCheck from "../pages/liveness-check";
import ContractCondition from "../pages/contract-condition";
import CustomerSignatureShow from "../pages/customer-signature-show";
import CustomerSignatureAction from "../pages/customer-signature-action";
import Congratulation from "../pages/congratulation";
import IdentityValidation from "../pages/identity-validation";
import TelephoneContact from "../pages/telephone-contact";
import DateExpire from "../pages/date-expire";
import FinishProcess from "../pages/finish-process";
import FollowLater from "../pages/follow-later";
import UseAccountManagementUps from "../pages/use-account-management/ups";
import UseAccountManagementRiskResponse from "../pages/use-account-management/risk-response";
import VideoCaptureCondition from "../pages/video-capture-condition";
import CustomizableViewOk from "../pages/customizable-view-ok";
import RetakePhone from "../pages/retake-phone";
import { PageNotFound } from "../pages/PageNotFound";
import { ErrorCredentials } from "../pages/ErrorCredentials";

type Status = "authenticated" | "no-authenticated";
const status: Status = "authenticated";
const persistor = persistStore(store);

const { getAuthOauthToken, getProcessesValidate } = new AuthenticationService();
const PrivateRoute = () => {
  const Authorization = localStorage.getItem("access_token")
    ? JSON.parse(localStorage.getItem("access_token") || "")
    : undefined;
  const access_uuid = localStorage.getItem("access_uuid")
    ? JSON.parse(localStorage.getItem("access_uuid") || "")
    : undefined;
  const access_reload = localStorage.getItem("access_reload")
    ? JSON.parse(localStorage.getItem("access_reload") || "0")
    : "0";
  const [status, setStatus] = useState<Status>("no-authenticated");
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = queryString.parse(location.search);

  const {
    dispatch,
    data: {
      authTokenPersist: { authToken = undefined },
      clientPersist: { uuid = undefined },
    },
  } = useRedux();

  const {
    data: dataAuthOauthToken,
    execute: executeSaveAuthOauthToken,
    isLoading: isAuthOauthToken,
    error: isErrorAuthOauthToken,
  } = useApi<IAccount, {}>(getAuthOauthToken);

  const {
    data: dataProcessesId,
    execute: executeProcessesId,
    isLoading: isProcessesId,
    error: isErrorProcessesId,
  } = useApi(getProcessesValidate);

  useEffect(() => {
    if (token) {
      executeSaveAuthOauthToken({});
    }
  }, []);

  useEffect(() => {
    if (token) {
      localStorage.setItem("uuid", token.toLocaleString().replace(" ", "+"));
      if (token && dataAuthOauthToken && !isAuthOauthToken && !isErrorAuthOauthToken) {
        dispatch(
          addAuthToken({
            authToken: dataAuthOauthToken.access_token,
            geoPosition: "MX",
            callerIP: "1.0.2.3",
          }),
        );
        localStorage.setItem("access_token", JSON.stringify(dataAuthOauthToken.access_token));
        executeProcessesId({
          token: token.toLocaleString().replace(" ", "+"),
          BearerToken: dataAuthOauthToken.access_token,
        }); //Cosulta processId
      }
    }
  }, [token, dataAuthOauthToken, isAuthOauthToken, isErrorAuthOauthToken]);

  useEffect(() => {
    if (dataProcessesId && !isProcessesId && !isErrorProcessesId) {
      dispatch(
        onClientReducer({
          token: authToken,
          uuid: dataProcessesId,
        }),
      );
      localStorage.setItem("access_uuid", JSON.stringify(dataProcessesId));
      setStatus("authenticated");
    } if (!dataProcessesId && !isProcessesId && isErrorProcessesId) {
      navigate("/error-credentials");
    }
  }, [dataProcessesId, isProcessesId, isErrorProcessesId]);

  useEffect(() => {
    if (status === "authenticated") {
      if (location.pathname.split("/")[1] === "start") {
        navigate("/InformationRequeriments");
        if(window.ReactNativeWebView){
          window.ReactNativeWebView.postMessage(JSON.stringify({type:'GET_PROCESS_ID', data:{ processId:uuid }}));
        }
      }
      if (location.pathname.split("/")[1] === "retake") {
        navigate("/InformationRequeriments");
        if(window.ReactNativeWebView){
          window.ReactNativeWebView.postMessage(JSON.stringify({type:'GET_PROCESS_ID', data:{ processId:uuid }}));
        }
      }
      localStorage.setItem("access_reload", "1");
      window.location.reload();
    }
  }, [status]);

  return (
    <PersistGate persistor={persistor}>
      {Authorization && access_uuid && status !== "authenticated" ? (
        <Routes>
          <Route path="/InformationRequeriments" element={<InformationRequeriments />} />
          <Route path="/AccountOpening" element={<AccountOpening />} />
          <Route path="/ValidateCode" element={<ValidateCode />} />
          <Route path="/IneConsent" element={<IneConsent />} />
          <Route path="/TermsCondition" element={<TermsCondition />} />
          <Route path="/CaptureINE" element={<CaptureINE />} />
          <Route path="/AddressCondition" element={<AddressCondition />} />
          <Route path="/DataConfirmation" element={<DataConfirmation />} />
          <Route path="/ProofAddressCondition" element={<ProofAddressCondition />} />
          <Route path="/SuggestionCaptureReceipt" element={<SuggestionCaptureReceipt />} />
          <Route path="/BlackLists" element={<BlackLists />} />
          <Route path="/FiscalInformationClient" element={<FiscalInformationClient />} />
          <Route path="/LaborInformation" element={<LaborInformation />} />
          <Route path="/UseAccountManagement" element={<UseAccountManagement />} />
          <Route path="/UseAccountManagement/ups" element={<UseAccountManagementUps />} />
          <Route
            path="/UseAccountManagement/management"
            element={<UseAccountManagementRiskResponse />}
          />
          <Route path="/BeneficiariesClient" element={<BeneficiariesClient />} />
          <Route path="/BeneficiariesCheckClient" element={<BeneficiariesCheckClient />} />
          <Route path="/IdentificationQuestionnaire" element={<IdentificationQuestionnaire />} />
          <Route path="/LivenessCheck" element={<LivenessCheck />} />
          <Route path="/ContractCondition" element={<ContractCondition />} />
          <Route path="/CustomerSignatureShow" element={<CustomerSignatureShow />} />
          <Route path="/CustomerSignatureAction" element={<CustomerSignatureAction />} />
          <Route path="/Congratulation" element={<Congratulation />} />
          <Route path="/IdentityValidation" element={<IdentityValidation />} />
          <Route path="/TelephoneContact" element={<TelephoneContact />} />
          
          <Route path="/FinishProcess" element={<FinishProcess />} />
          <Route path="/FollowLater" element={<FollowLater />} />
          <Route path="/VideoCaptureCondition" element={<VideoCaptureCondition />} />
          <Route path="/CustomizableViewOk" element={<CustomizableViewOk />} />
          <Route path="/DateExpire" element={<DateExpire />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="" element={<div className="loading">No credentials... v0.0.08-alpha</div>} />
          <Route
            path="/"
            element={<div className="loading">No credentials... v0.0.08-alpha </div>}
          />
          <Route
            path="/start"
            element={<div className="loading">No credentials... v0.0.08-alpha</div>}
          />
          <Route
            path="/retake"
            element={<div className="loading">No credentials... v0.0.08-alpha</div>}
          />
          <Route path="/retake-phone" element={<RetakePhone />} />
          <Route path="/error-credentials" element={<ErrorCredentials />} />
          
        </Routes>
      )}
    </PersistGate>
  );
};

export default PrivateRoute;
